<template>
    <div class="flex h-full overflow-hidden">
        <reports-menu 
            :report-data="allReports"
            :selected-category="report.category_id"
            @category-selected="handleCategorySelected"
        />
        <site-report-prep
            :report-name="report.name"
            :report-slug="report.slug"
            :report-type="reportType"
            :items="items"
            :include-options-list="includeOptionsList"
        />
    </div>
</template>

<script>
import ReportsMenu from './ReportsMenu.vue';
import SiteReportPrep from './SiteReportPrep.vue';

export default {
    name: 'ReportPrepPage',
    
    components: {
        ReportsMenu,
        SiteReportPrep
    },

    props: {
        allReports: {
            type: Array,
            default: () => []
        },
        report: {
            type: Object,
            required: true
        },
        reportType: {
            type: String,
            default: 'site' // 'site' or 'project'
        },
        items: {
            type: Array,
            default: () => []
        },
        includeOptions: {
            type: Array,
            default: () => []
        }
    },

    computed: {
        includeOptionsList() {
            // Convert include options to the format expected by the prep component
            return this.includeOptions;
        }
    },

    methods: {
        handleCategorySelected(categoryId) {
            // Navigate to reports index with category filter
            if (categoryId === '') {
                window.location = '/reports';
            }
        }
    }
};
</script>
